import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';

export default class Leave extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            loading: false,
            toTime: "",
            inputToTime: "",
        };

        this.state.inputFromTime = this.state.caller.state.data.record.leaveRequest.fromTime != 0 ? this.formatTimeForInput(this.state.caller.state.data.record.leaveRequest.fromTime.toString()) : "";

        this.state.inputToTime = this.state.caller.state.data.record.leaveRequest.toTime != 0 ? this.formatTimeForInput(this.state.caller.state.data.record.leaveRequest.toTime.toString()) : "";

    }
    formatTimeForInput = (timeString) => {
        if (timeString.length === 5)
            timeString = "0" + timeString;
        if (timeString.length === 6) {
            return `${timeString.slice(0, 2)}:${timeString.slice(2, 4)}:${timeString.slice(4, 6)}`;
        }
        return "";
    }
    validateTime = (timeString) => {
        if (!/^\d{6}$/.test(timeString)) return "فرمت ساعت نادرست است!";

        const hours = parseInt(timeString.slice(0, 2), 10);
        const minutes = parseInt(timeString.slice(2, 4), 10);
        const seconds = parseInt(timeString.slice(4, 6), 10);

        if (hours < 0 || hours > 23) return "ساعت باید بین 00 تا 23 باشد!";
        if (minutes < 0 || minutes > 59) return "دقیقه باید بین 00 تا 59 باشد!";
        if (seconds < 0 || seconds > 59) return "ثانیه باید بین 00 تا 59 باشد!";

        return "";
    }
    handleFromTimeChange = (e) => {
        const value = e.target.value; // مقدار ورودی در فرمت HH:mm:ss
        if (value) {
            const formattedTime = value.replace(/:/g, ""); // حذف دو نقطه
            var resValidate = this.validateTime(formattedTime);
            if (resValidate) {
                this.showErorrMessage(resValidate);
                return;
            }
            this.state.caller.state.data.record.leaveRequest.fromTime = formattedTime;
            this.setState({
                inputFromTime: value
            });
        } else {
            this.setState({
                time: ""
            });
        }
    }
    handleToTimeChange = (e) => {
        const value = e.target.value; // مقدار ورودی در فرمت HH:mm:ss
        if (value) {
            const formattedTime = value.replace(/:/g, ""); // حذف دو نقطه
            var resValidate = this.validateTime(formattedTime);
            if (resValidate) {
                this.showErorrMessage(resValidate);
                return;
            }
            this.state.caller.state.data.record.leaveRequest.toTime = formattedTime;
            this.setState({
                inputToTime: value
            });
        } else {
            this.setState({
                time: ""
            });
        }
    }
    renderForm() {
        return <div className="row" style={{ "backgroundColor": "beige", "paddingTop": "15px", "paddingBottom": "15px"}}>
            <div className="col-lg-12">
            <h4>اطلاعات درخواست مرخصی</h4>
            </div>
            <div className="col-lg-2">
                <div className="form-group">
                    <label className="form-label">نوع</label>
                    <div className="form-control-wrap">
                        <select className="form-control" defaultValue={this.state.caller.state.data.record.leaveRequest.type} onChange={e => this.state.caller.state.data.record.leaveRequest.type = parseInt(e.target.value)}>
                            <option value="1">استحقاقی</option>
                            <option value="2">استعلاجی</option>
                            <option value="3">بدون حقوق</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-lg-2">
                <div className="form-group">
                    <label className="form-label">بازه زمانی</label>
                    <div className="form-control-wrap">
                        <select className="form-control" defaultValue={this.state.caller.state.data.record.leaveRequest.type} onChange={e => this.state.caller.state.data.record.leaveRequest.type = parseInt(e.target.value)}>
                            <option value="1">روزانه</option>
                            <option value="2">ساعتی</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">از تاریخ :</label>
                    <div className="form-control-wrap">
                        <DatePicker
                            inputReadOnly={false}
                            className="form-control persian-date ltr"
                            placeholder={"تاریخ"}
                            isGregorian={false}
                            showTodayButton={true}
                            timePicker={false}
                            onChange={(e) => { this.state.caller.state.data.record.leaveRequest.fromDate = e }}
                            value={this.getFormatedDateForDatePicker(this.state.caller.state.data.record.leaveRequest.fromDate)}
                        />
                    </div>
                </div>
            </div>
            <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">از ساعت:</label>
                    <div className="form-control-wrap">
                        <input
                            type="time"
                            value={this.state.inputFromTime}
                            onChange={e => this.handleFromTimeChange(e)}
                            className="form-control input-sm"
                            step="1"
                        />
                    </div>
                </div>
            </div>
            <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">تا تاریخ :</label>
                    <div className="form-control-wrap">
                        <DatePicker
                            inputReadOnly={false}
                            className="form-control persian-date ltr"
                            placeholder={"تاریخ"}
                            isGregorian={false}
                            showTodayButton={true}
                            timePicker={false}
                            onChange={(e) => { this.state.caller.state.data.record.leaveRequest.toDate = e }}
                            value={this.getFormatedDateForDatePicker(this.state.caller.state.data.record.leaveRequest.toDate)}
                        />
                    </div>
                </div>
            </div>
            <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">تا ساعت:</label>
                    <div className="form-control-wrap">
                        <input
                            type="time"
                            value={this.state.inputToTime}
                            onChange={e => this.handleToTimeChange(e)}
                            className="form-control input-sm"
                            step="1"
                        />
                    </div>
                </div>
            </div>
            {this.state.caller.state.data.record.id !== this.getDefaultGuid() && <div className="col-lg-2">
                <div className="form-group">
                    <label className="form-label">وضعیت</label>
                    <div className="form-control-wrap">
                        <select className="form-control" defaultValue={this.state.caller.state.data.record.leaveRequest.status} onChange={e => this.state.caller.state.data.record.leaveRequest.status = parseInt(e.target.value)}>
                            <option value="1">در انتظار بررسی</option>
                            <option value="2">موافقت شده</option>
                            <option value="3">موافقت نشده</option>
                        </select>
                    </div>
                </div>
            </div>}
        </div>

    }
    render() {
        return this.renderForm();
    }
}